/* eslint-disable */
const getters = {
  getContest(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
